import { useState } from "react";

import {
  Checkbox,
  InputLabel,
  Button,
} from "@mui/material"
import { createTrial } from "../../services/otp";
import { completeKwikLogin } from "../../services/auth";
import { emitSnackbar } from "../../lib/snackbar-emitter";
import { loader } from "../../lib/loader";
import manageErrors from "../../lib/error-management";
import { useNavigate } from "react-router-dom";

interface Step3Props {
  onNext: () => void;
  data: any;
}

//const TERMS_AND_CONDITIONS_URL = "https://docs.google.com/document/d/1DR4vZmqvf54jyXgEpmbEgad66qM6rhZMul6roDNZTAo/preview?tab=t.0#heading=h.711ghasvhksy"
const TERMS_AND_CONDITIONS_URL = "https://docs.google.com/document/d/e/2PACX-1vSw5olP1sRyVoewugkTFwdS9MwY4IMnSWhFiRb2QfX3QoU6c4GZGmDsP4Re1fNyBHTJj2VT7UrMk9P9/pub?embedded=true"

const Step3TermsAndConditions = ({ data }: Step3Props) => {
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);

  const finalizeProcess = async () => {
    if (!data?.session_id) {
      emitSnackbar({message: 'Sessão de validação inválida. Recomece o cadastro.', severity: 'error'})
      return
    }

    const monitoredTelephone = data?.adminData?.monitoring_telephone
    if (!monitoredTelephone) {
      emitSnackbar({message: 'Telefone monitorado inválido. Recomece o cadastro.', severity: 'error'})
      return
    }

    setLoading(true)
    loader.on()

    try {
      const response = await createTrial(data.session_id, {
        telephone: monitoredTelephone,
        test_myself: !!data?.adminData?.test_myself,
      })

      if (response.ok) {
        const responseData = response.data
        const loginResult = await completeKwikLogin(responseData)

        if (!loginResult.ok) {
          emitSnackbar({message: loginResult.error || 'Não foi possível concluir a autenticação.', severity: 'error'})
          return
        }

        navigate('/home')
      } else {
        emitSnackbar({message: manageErrors(response.data), severity: 'error'})
      }
    } finally {
      setLoading(false)
      loader.off()
    }
  }

  return (
    <div className="w-full max-w-lg mx-auto flex flex-col gap-4">
      <div className="w-full h-[40vh] border rounded overflow-hidden">
        <iframe
          src={TERMS_AND_CONDITIONS_URL}
          title="Termos e Condições"
          className="w-full h-full"
        />
      </div>
      {/*<p className="text-center">
        <button
          onClick={() => window.open(TERMS_AND_CONDITIONS_URL, "_blank")}
          className="text-sm text-muted-foreground hover:text-foreground underline transition-colors"
        >
          Abrir em outra aba do navegador
        </button>
      </p>*/}
      <div className="flex items-center space-x-2">
        <Checkbox
          id="terms"
          checked={accepted}
          onChange={({target}) => setAccepted(!!target.checked)} />

        <InputLabel htmlFor="terms" className="text-sm text-muted-foreground cursor-pointer">
          Aceito os termos e condições de uso
        </InputLabel>
      </div>
      <Button
        className="w-full"
        size="large"
        disabled={!accepted || loading}
        variant='contained'
        onClick={finalizeProcess}
      >
        {loading ? 'Aguarde' : 'Finalizar cadastro'}
      </Button>
    </div>
  );
};

export default Step3TermsAndConditions;